import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@mui/material';

import {
  FCheckbox as LegacyFCheckbox,
  FHTooltip,
} from '../../../../../../components/base';
import { FCheckbox } from '../../../../../../components/baseV2';
import {
  CHECKLIST_OPTION_ROW_SX,
  CHECKLIST_TOOLTIP_BACKGROUND,
  CHECKLIST_TOOLTIP_SX,
  INFO_ICON_STYLE,
} from '../styles';
import { buildCheckboxTestId } from '../utils';

import type { ChecklistOptionRowProps } from '../types';

export default function ChecklistOptionRow({
  isEditable,
  item,
  onChange,
  useNewUi,
}: ChecklistOptionRowProps) {
  return (
    <Box sx={CHECKLIST_OPTION_ROW_SX}>
      {useNewUi ? (
        <FCheckbox
          data-testid={buildCheckboxTestId(item.label)}
          label={item.label}
          checked={item.checked}
          disabled={!isEditable}
          onChange={(event) => onChange(item.id, event.target.checked)}
        />
      ) : (
        <LegacyFCheckbox
          data-testid={buildCheckboxTestId(item.label)}
          label={item.label}
          checked={item.checked}
          disabled={!isEditable}
          onChange={(event) => onChange(item.id, event.target.checked)}
        />
      )}
      <FHTooltip
        title={item.description}
        sx={CHECKLIST_TOOLTIP_SX}
        tooltipBoxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
        arrow
        tooltipbackground={CHECKLIST_TOOLTIP_BACKGROUND}
      >
        <InfoOutlinedIcon fontSize="small" style={INFO_ICON_STYLE} />
      </FHTooltip>
    </Box>
  );
}
